import React, { useState, useEffect } from 'react'
import { arrayOf, shape, string, bool, number } from 'prop-types'
import classnames from 'classnames'

import Container from 'components/atoms/Container'

import isDOMAvailable from 'utils/isDOMAvailable'

const StickySectionNav = ({ sections, afterElement, topOffset }) => {
  const [display, setDisplay] = useState(false)
  const [hidden, setHidden] = useState(true)

  const scrollToSection = (e) => {
    e.preventDefault()
    const sectionTarget = e.target.getAttribute('href')
    if (isDOMAvailable && document) {
      const menuContainer = document.querySelector('.sticky-section-nav__bar>.cmps-container')
      const itmLeftOffset = e.target.offsetLeft - menuContainer.offsetLeft

      window.location.hash = sectionTarget
      menuContainer.scroll({
        left: itmLeftOffset,
        behavior: 'smooth',
      })
      window.scroll({
        top: document.querySelector(sectionTarget).offsetTop - 110,
        behavior: 'smooth',
      })
    }
  }

  const windowScrollToggle = () => {
    const positionToAppear = document &&
      document.querySelector(afterElement) &&
      document.querySelector(afterElement).offsetHeight

    if (window.scrollY > positionToAppear) {
      !display && setDisplay(true)
      hidden && setHidden(false)
    } else {
      display && setDisplay(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', windowScrollToggle())
    return (
      window.removeEventListener('scroll', windowScrollToggle())
    )
  })

  const classNameVal = classnames('sticky-section-nav__bar', {
    'slide-in-top': display,
    'slide-out-top': !display,
  })

  return (
    <div className="sticky-section-nav">
      <div className={classNameVal}>
        <Container className="sticky-section-nav__container">
          <div className="sticky-section-nav__list">
            {
              sections.map(section => (
                section.show &&
                <a
                  className="sticky-section-nav__item"
                  href={section.target}
                  key={`tgt-${section.target}`}
                  onClick={scrollToSection}
                  title={section.text}
                >
                  {section.text}
                </a>
              ))
            }
          </div>
        </Container>

        <style jsx>
          {`
            .sticky-section-nav {
              :global(&__container) {
                overflow: scroll;
                @media screen and (min-width: 992px) {
                  overflow: hidden;
                }
              }
              &__bar {
                background: #fff;
                height: 56px;
                display: ${!hidden ? 'flex' : 'none'};
                align-items: center;
                box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
                position: fixed;
                top: ${topOffset || 0}px;
                width: 100%;
                margin-top: -5px;
                padding-top: 5px;
                z-index: 2;
              }
              &__list {
                width: fit-content;
                display: inline-flex;
                flex-wrap: nowrap;
              }
              &__item {
                color: #1e3f6b;
                font-weight: 700;
                display: inline-flex;
                font-size: 14px;
                flex-shrink: 0;
                &:not(:last-child) {
                  &::after {
                    content: "";
                    display: inline-block;
                    width: 7px;
                    height: 7px;
                    margin-left: 10px;
                    margin-right: 10px;
                    margin-top: auto;
                    margin-bottom: auto;
                    background-color: #1e3f6b;
                    border-radius: 100%;
                  }
                }
                &:hover, &:active, &:focus {
                  color: #0fc3c4;
                  text-decoration: none;
                }
              }
            }
            /* entrance animation */
            .slide-in-top {
              animation: slide-in-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
            }
            @keyframes slide-in-top {
              0% {
                transform: translateY(-1000px);
                opacity: 0;
              }
              100% {
                transform: translateY(0);
                opacity: 1;
              }
            }
            /* exit animation */
            .slide-out-top {
              animation: slide-out-top 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
            }
            @keyframes slide-out-top {
              0% {
                transform: translateY(0);
                opacity: 1;
              }
              100% {
                transform: translateY(-1000px);
                opacity: 0;
              }
            }
            .hidden {
              display: none;
            }
          `}
        </style>
      </div>
      <button
        type="button"
        className="hidden"
        data-testid="displayTrue"
        onClick={
          () => {
            setDisplay(true)
            setHidden(false)
          }
        }
      >
        displaytrue
      </button>
    </div>
  )
}

StickySectionNav.propTypes = {
  sections: arrayOf(
    shape({
      target: string,
      text: string,
      show: bool,
    })
  ),
  afterElement: string,
  topOffset: number,
}

StickySectionNav.defaultProps = {
  afterElement: '.campus-page-banner',
}

export default StickySectionNav
